import type { PublicPlaceCandidate } from "@natural/public-contract";
import type { FishingTrip } from "./contracts";

type ApiError = { error?: { message?: string } };

export async function accountApi<T>(
  path: string,
  init?: RequestInit,
): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: { "content-type": "application/json", ...init?.headers },
  });
  const value = (await response.json().catch(() => ({}))) as T & ApiError;
  if (!response.ok)
    throw Object.assign(
      new Error(value.error?.message ?? "Palvelupyyntö epäonnistui."),
      { status: response.status },
    );
  return value;
}

export async function accountFormApi<T>(path:string,form:FormData,method="POST"):Promise<T>{
  const response=await fetch(path,{method,body:form});
  const value=(await response.json().catch(()=>({})))as T&ApiError;
  if(!response.ok)throw Object.assign(new Error(value.error?.message??"Palvelupyyntö epäonnistui."),{status:response.status});
  return value;
}

const pendingTripKey = "lupava_pending_trip";

export async function completePendingConsumerActions() {
  const pendingTrip = sessionStorage.getItem(pendingTripKey);
  if (pendingTrip) {
    let value: {
      place: PublicPlaceCandidate;
      activity: FishingTrip["activity"];
      rodCount: number;
      date: string;
      lastCheckedAt: string;
      lastCoreChecksum: string | null;
      lastGuidanceStatus: NonNullable<FishingTrip["last_guidance_status"]>;
    };
    try {
      value = JSON.parse(pendingTrip) as typeof value;
    } catch {
      sessionStorage.removeItem(pendingTripKey);
      return;
    }
    const place = await accountApi<{ id: string }>(
      "/api/account/saved-places",
      { method: "POST", body: JSON.stringify(value.place) },
    );
    await accountApi("/api/account/trips", {
      method: "POST",
      body: JSON.stringify({
        savedPlaceId: place.id,
        activity: value.activity,
        rodCount: value.rodCount,
        plannedDate: value.date,
        notes: "",
        lastCheckedAt: value.lastCheckedAt,
        lastCoreChecksum: value.lastCoreChecksum,
        lastGuidanceStatus: value.lastGuidanceStatus,
      }),
    });
    sessionStorage.removeItem(pendingTripKey);
    sessionStorage.removeItem("lupava_pending_place");
    return;
  }
  const pendingPlace = sessionStorage.getItem("lupava_pending_place");
  if (pendingPlace) {
    await accountApi("/api/account/saved-places", {
      method: "POST",
      body: pendingPlace,
    });
    sessionStorage.removeItem("lupava_pending_place");
  }
}
